// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum TransferPaymentType {
  Unspecified = "UNSPECIFIED",
  Domestic = "DOMESTIC",
  Foreign = "FOREIGN",
  Sepa = "SEPA",
}
export default TransferPaymentType;
